
export default class ShareYourVisionDonationUrlGenerator {
  constructor(el) {
    this.el = el;

    if (!this.el) {
      return false;
    }

    this.form = this.el.querySelector('form');
    this.emailField = this.el.querySelector('[data-email]');
    this.honeypotField = this.el.querySelector('input[name="name"]');
    this.submit = this.el.querySelector('[data-submit]');
    this.urlField = this.el.querySelector('[data-url]');
    this.copy = this.el.querySelector('[data-copy]');
    this.copyWrapper = this.el.querySelector('[data-copy-wrapper]');
    this.copyMessage = this.el.querySelector('[data-copy-message]');

    this.init();
  }

  init() {
    this.form.addEventListener('submit', (event) => {
      event.preventDefault();
      this.email = this.emailField.value;
      this.honeypot = this.honeypotField.value;
      if (this.email && !this.honeypot) {
        this.createUrl();
      }
    });

    this.copy.addEventListener('click', (event) => {
      event.preventDefault();
      navigator.clipboard.writeText(this.url).then(
        // Success
        () => {
          this.copy.classList.add('copied');
          this.copy.setAttribute('aria-label', 'Copied.');
          this.copyMessage.setAttribute('style', 'display: block;');
          // Remove class after a short delay
          setTimeout(() => {
            this.copy.classList.remove('copied');
            this.copy.setAttribute('aria-label', 'Copy Your Custom URL');
            this.copyMessage.setAttribute('style', 'display: none;');
          }, 3000);
        },
        // Failure
        () => {
          this.copy.classList.remove('copied');
          this.copyMessage.setAttribute('style', 'display: none;');
        }
      );
    });
  }

  async createUrl() {
    const csrf_token = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
    const location = "/shareyourvision/generate-donation-url";

    let data = {
      email: this.email,
      name: this.honeypot
    };

    const settings = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-CSRF-Token': csrf_token
      },
      body: JSON.stringify(data)
    };
    try {
        const fetchResponse = await fetch(location, settings);
        await fetchResponse.json().then(json => {
          if (json.url) {
            this.url = json.url;
            this.urlField.textContent = this.url;
            this.copyWrapper.setAttribute('style', 'display: flex;');
          }
        });
    } catch (e) {
      console.log(e);
      this.copyWrapper.setAttribute('style', 'display: none;');
    }
  }
}


const items = document.querySelectorAll(".ShareYourVisionDonationUrlGenerator");

items.forEach((item) => {
  new ShareYourVisionDonationUrlGenerator(item);
});
